export const config = {
	// the name of the app
	appName: "SkillQuest",

	// the link to the documentation app (if not defined, the documentation link will not be shown in the app)
	docsLink: process.env.NEXT_PUBLIC_DOCS_URL as string | undefined,

	// the themes that should be available in the app
	enabledThemes: ["light", "dark", "system"],
	// the default theme
	defaultTheme: "light",

	// the saas part of the application
	saas: {
		// whether the saas part should be enabled (otherwise all routes will be redirect to the marketing page)
		enabled: true,

		// whether the sidebar layout should be used
		useSidebarLayout: true,

		/**
		 * When false (default), Coming Soon nav missions are omitted from the sidebar.
		 * Set `NEXT_PUBLIC_SHOW_COMING_SOON_NAV=true` to show disabled Coming Soon entries.
		 */
		showComingSoonNav:
			process.env.NEXT_PUBLIC_SHOW_COMING_SOON_NAV === "true",

		/**
		 * Character 3D (R3F) body art — default ON for ready-to-test.
		 * Emergency rollback: NEXT_PUBLIC_CHARACTER_3D_ENABLED=false
		 */
		character3dEnabled:
			process.env.NEXT_PUBLIC_CHARACTER_3D_ENABLED !== "false",

		/**
		 * Scene Studio 3D build pipeline — default OFF until PS+ dogfood.
		 * Enable: NEXT_PUBLIC_SCENE_3D_BUILD_ENABLED=true
		 */
		scene3dBuildEnabled:
			process.env.NEXT_PUBLIC_SCENE_3D_BUILD_ENABLED === "true",

		/**
		 * Scene prop UniMate Animate — dev/test default ON; production template OFF
		 * until LICENSE_GATE counsel. Override: NEXT_PUBLIC_SCENE_PROP_ANIMATE_ENABLED.
		 */
		scenePropAnimateEnabled:
			process.env.NEXT_PUBLIC_SCENE_PROP_ANIMATE_ENABLED !== undefined
				? process.env.NEXT_PUBLIC_SCENE_PROP_ANIMATE_ENABLED === "true"
				: process.env.NODE_ENV !== "production",

		/**
		 * Scene motion backend: off | unimate (customer path only; no staff fork).
		 */
		sceneMotionBackend: (process.env.SCENE_MOTION_BACKEND === "unimate"
			? "unimate"
			: "off") as "off" | "unimate",

		/** Learner WebGL prop draw budget + Tripo remesh faces (mirror api domain). */
		scenePropMaxDraws: 48,
		scenePropRemeshFacesInteractable: 10_000,
		scenePropRemeshFacesEnvironment: 5_000,

		// the redirect path after sign in
		redirectAfterSignIn: "/app",

		// the redirect path after logout
		redirectAfterLogout: "/auth/login",
	},

	// the marketing part of the application
	marketing: {
		// whether the marketing features should be enabled (otherwise all routes will be redirect to the saas part)
		enabled: true,
		/** Inbound contact address for marketing demo mailto links (`CONTACT_FORM_TO_MAIL`). */
		contactFormToMail: process.env.NEXT_PUBLIC_CONTACT_FORM_TO_MAIL ?? "",
	},

	/**
	 * UserNotification retention (server): max rows per user; prune older rows in background when inserting past this cap.
	 * Client notification panel paginates with `listPageSize` rows per scroll batch (see `StackedListCardLazy`).
	 */
	userNotifications: {
		maxStoredPerUser: 50,
		listPageSize: 10,
		/**
		 * Poll unread count while the org shell is mounted (no websocket inbox).
		 * Keeps the badge reasonably fresh when other users trigger notifications.
		 */
		unreadPollIntervalMs: 45_000,
		/**
		 * Poll on the dedicated notifications page (list + unread).
		 */
		inboxPagePollIntervalMs: 60_000,
		/**
		 * When the header notifications panel is open, poll the list a bit faster.
		 */
		headerPanelListPollIntervalMs: 20_000,
	},

	/** Client analytics (provider selected via `NEXT_PUBLIC_ANALYTICS_PROVIDER`). */
	analytics: {
		provider: process.env.NEXT_PUBLIC_ANALYTICS_PROVIDER ?? "custom",
		/**
		 * Ingestion / API base (reverse proxy on our domain, or PostHog regional `*.i.posthog.com`).
		 * @see https://posthog.com/docs/advanced/proxy
		 */
		posthogHost:
			process.env.NEXT_PUBLIC_POSTHOG_HOST ??
			"https://platform.skillquestapp.com",
		/**
		 * PostHog **app** origin for toolbar / session replay links when `api_host` is a proxy.
		 * EU cloud: `https://eu.posthog.com` — override if you use US or self-hosted.
		 */
		posthogUiHost:
			process.env.NEXT_PUBLIC_POSTHOG_UI_HOST ?? "https://eu.posthog.com",
	},
} as const;
